import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import theme from './theme';
import EmbeddedView from './embeddedViews/EmbeddedView';
import ContextWrapper from './components/ContextWrapper';
import NotFoundPage from './views/NotFoundPage';
import { useDomainRegion } from './hooks';
import AvailableDomainsPage from './views/AvailableDomainsPage';
import EmbeddedBaseView from './embeddedViews/EmbeddedBaseView';

const router = createBrowserRouter([
    {
        path: '/',
        element: <ContextWrapper />,
        children: [
            {
                path: '',
                element: (
                    <EmbeddedBaseView>
                        <EmbeddedView />
                    </EmbeddedBaseView>
                )
            },
            {
                path: '*',
                element: (
                    <EmbeddedBaseView>
                        <NotFoundPage />
                    </EmbeddedBaseView>
                )
            }
        ]
    }
]);

export default function Embedded() {
    const { status } = useDomainRegion();

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {status !== 'error' ? (
                <RouterProvider router={router} />
            ) : (
                <EmbeddedBaseView missingRegionData>
                    <AvailableDomainsPage />
                </EmbeddedBaseView>
            )}
        </ThemeProvider>
    );
}
